module.exports = __webpack_public_path__ + "img/bdfe1dc.jpg";